import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { _HttpClient } from 'src/app/core/net/http.client';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/core/net/apiRoute';


@Component({
  templateUrl: './forgetpassword.component.html',
  styleUrls: ['./forgetpassword.component.css']
})
export class ForgetpasswordComponent implements OnInit {
  error = ''; // 错误信息
  nzType = 'error'; // 提示框类型 默认错误
  count = 0; // 验证码倒计时
  interval$: any;
  public checkoutForm: FormGroup;
  type = 0; // 找回密码方式 1.短信验证码  2.邮箱

  constructor(private formBuilder: FormBuilder, public router: Router, public http: _HttpClient) {
    this.checkoutForm = this.formBuilder.group({
      phone: [null, [Validators.required, Validators.pattern(/^1\d{10}$/)]],
      email: [null, [Validators.required, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9._%+-]{2,}[.][A-Za-z]{2,}$')]],
      code: [null, [Validators.required, Validators.minLength(6)]],
      password: [null, [Validators.required, Validators.minLength(4)]],
      newpassword: [null, [Validators.required, Validators.minLength(4)]],
    });
  }
  get email() {
    return this.checkoutForm.controls.email;
  }

  get phone() {
    return this.checkoutForm.controls.phone;
  }

  get code(){
    return this.checkoutForm.controls.code;
  }

  get password() {
    return this.checkoutForm.controls.password;
  }

  get newpassword() {
    return this.checkoutForm.controls.newpassword;
  }

  ngOnInit(): void {
  }

  // 验证方式切换
  switch(ret: any) {
    this.type = ret.index;
  }

  onSubmit(data) {
    this.phone.markAsDirty();
    this.phone.updateValueAndValidity();
    this.code.markAsDirty();
    this.code.updateValueAndValidity();
    this.email.markAsDirty();
    this.email.updateValueAndValidity();
    this.password.markAsDirty();
    this.password.updateValueAndValidity();
    this.newpassword.markAsDirty();
    this.newpassword.updateValueAndValidity();
    if ( this.type === 0 ){
      if (this.phone.invalid ) {
        this.error = '请输入正确的手机号';
        return;
      }
      else if ( this.code.invalid){
        this.error = '请输入手机验证码';
        return;
      }
    }
    else if (this.type === 1 )
    {
      if (this.email.invalid ) {
        this.error = '请输入注册邮箱';
        return;
      }
      else if ( this.code.invalid){
        this.error = '请输入邮箱验证码';
        return;
      }
    }
    if ( this.password.invalid ){
      this.error = '请输入新密码';
      return;
    }
    else if ( this.newpassword.invalid ){
      this.error = '请输入确认密码';
      return;
    }
    // tslint:disable-next-line: triple-equals
    else if ( this.newpassword.value != this.password.value ){
      this.error = '两次密码不一致';
      return;
    }

    this.http.post(ApiService.ForgetPassword, {
      type: this.type,
      phone: this.phone.value,
      code: this.code.value,
      newPassword: this.password.value
    })
      .subscribe((res: any) => {
        this.error = res.Message;
        if (res.Status !== 1) {
          return;
        }
        else{
          this.nzType = 'success';
          setTimeout(() => {
            this.router.navigate(['login']);
          }, 2000);
        }
      });
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy(): void {
    if (this.interval$) { clearInterval(this.interval$); }
  }
  // 获取验证码
  getCaptcha(): any{
    if (this.phone.invalid) {
      this.error = '请输入正确的手机号';
      this.phone.markAsDirty({ onlySelf: true });
      this.phone.updateValueAndValidity({ onlySelf: true });
      return;
    }
    this.http.post(ApiService.SendPhoneCode, {
      phone: this.phone.value,
      type: 1
    })
      .subscribe((res: any) => {
        if (res.Status !== 1) {
          this.error = res.Message;
          return;
        }
        this.count = 60;
        this.interval$ = setInterval(() => {
          this.count -= 1;
          if (this.count <= 0) {
            clearInterval(this.interval$);
          }
        }, 1000);
      });
  }
}
